import React from 'react';

const ShareIcon = ({ width = 18, height = 18, color = 'white' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none">
      <path
        d="M21.5 2.5L14.85 21.5L11.05 12.95L2.5 9.15L21.5 2.5Z"
        stroke={color}
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path d="M21.5 2.5L11.05 12.95" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default ShareIcon;
